// extracted by mini-css-extract-plugin
export default {"wrapper":"EventMarket_wrapper--QKA","eventMarket":"EventMarket_eventMarket--I4v","button":"EventMarket_button--xQQ","table":"EventMarket_table--HBH"};